import styled from 'styled-components';
import { P, PProps } from 'ia-react-core';
import { FC } from 'react';

export const StyledServiceCenter = styled<FC<PProps>>(P)`
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 20px;
`;
